import { WarningErrorIcon } from "vega-icons";

import { m } from "@vega-core/paraglide/messages";

type Props = {
  errorMessage?: string;
  errorDescription?: string;
};

export const InvalidCodeMessage = ({
  errorMessage,
  errorDescription,
}: Props) => (
  <div className="flex flex-col gap-3">
    <WarningErrorIcon className="text-text/negative" />
    <h4 className="heading-4 text-text/primary font-semibold">
      {errorMessage || m.errors_invalidRegistrationCode()}
    </h4>
    <div className="body-base-regular text-text/primary">
      {errorDescription
        ? errorDescription
        : m.registration_checkCodeErrorDescription()}
    </div>
  </div>
);
